(function() {
  var DI,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DI = require('resources/assets/coffee/Core/DependencyInjection').DependencyInjection;

  exports.Handler = (function(superClass) {
    extend(Handler, superClass);

    function Handler(name, data) {
      var ref, ref1;
      if (data == null) {
        data = {};
      }
      this._getLayoutSelector = bind(this._getLayoutSelector, this);
      Handler.__super__.constructor.call(this);
      App.load('core::widget_resizr');
      this.__destroyed = false;
      this.__request = null;
      this.nameInParent = null;
      this.layoutSelector = (ref = App.sidebar) != null ? ref.contentDiv() : void 0;
      this.sidebar_open = true;
      this.emptySidebarWriter = true;
      this.autofocus = true;
      this.removeMessageOnLoad = true;
      this.layoutUrl = name + "/load-layout";
      this.extraData = data;
      this.taffyObjects = {};
      this.singleSubHandler = true;
      this.activeSubHandlers = {};
      if ((ref1 = App.sidebar) != null) {
        ref1.messageWriter().message_writer('clear');
      }
    }

    Handler.prototype.isDestroyed = function() {
      return this.__destroyed;
    };

    Handler.prototype.init = function() {
      return void 0;
    };

    Handler.prototype.destroy = function(clear) {
      var i, ref, selector, v;
      if (clear == null) {
        clear = true;
      }
      this.__destroyed = true;
      if (this.__request != null) {
        this.__request.abort();
      }
      ref = this.activeSubHandlers;
      for (i in ref) {
        v = ref[i];
        v.destroy();
      }
      selector = this._getLayoutSelector();
      if ((selector != null) && clear) {
        if (selector.length > 0) {
          ko.cleanNode(selector[0]);
        }
        selector.empty();
      }
      if (this.emptySidebarWriter && App.sidebar.messageWriter().data('customMessage_writer')) {
        App.sidebar.messageWriter().message_writer('clear');
      }
      if (this.parent != null) {
        return this.parent.destroySubHandler(this.nameInParent);
      }
    };

    Handler.prototype._getLayoutSelector = function(selector) {
      if (selector == null) {
        selector = this.layoutSelector;
      }
      if (selector != null) {
        if (selector instanceof jQuery) {
          return selector;
        }
        return $(selector);
      }
      return null;
    };

    Handler.prototype.refresh = function(clear) {
      var i, ref, selector, v;
      if (clear == null) {
        clear = true;
      }
      ref = this.activeSubHandlers;
      for (i in ref) {
        v = ref[i];
        v.destroy();
      }
      selector = this._getLayoutSelector();
      if ((selector != null) && clear) {
        selector.empty();
      }
      return this.init();
    };


    /*
    If the subs are TABS and they are in App.sidebar.contentDiv(), they should automagically work
    (if they were named correctly)
     */

    Handler.prototype.createSubHandler = function(sub, name) {
      var handler, handlerObj, i, k, object, ref, ref1, ref2, ref3, ref4, ref5, ref6, v;
      if (name == null) {
        name = null;
      }
      if (this.__destroyed) {
        return null;
      }
      handler = (ref = ((ref1 = this.subHandlers) != null ? (ref2 = ref1[sub]) != null ? ref2["class"] : void 0 : void 0)) != null ? ref : sub;
      if (!handler) {
        return null;
      }
      name = name != null ? name : handler;
      if (this.singleSubHandler) {
        ref3 = this.activeSubHandlers;
        for (i in ref3) {
          v = ref3[i];
          v.destroy();
        }
      } else if (this.activeSubHandlers[name] != null) {
        return false;
      }
      if (typeof handler === 'string') {
        object = window.App.loadClass(handler);
      } else {
        object = handler;
      }
      handlerObj = new object();
      handlerObj.nameInParent = name;
      handlerObj.parent = this;
      this.activeSubHandlers[name] = handlerObj;
      if ((ref4 = this.subHandlers) != null ? (ref5 = ref4[sub]) != null ? ref5.attrs : void 0 : void 0) {
        ref6 = this.subHandlers[sub].attrs;
        for (k in ref6) {
          v = ref6[k];
          this.activeSubHandlers[name][k] = v;
        }
      }
      return this.activeSubHandlers[name];
    };

    Handler.prototype.destroySubHandler = function(name, calldestroy) {
      var ref, ref1;
      if (calldestroy == null) {
        calldestroy = false;
      }
      if (((ref = this.subHandlers) != null ? ref[name] : void 0) != null) {
        name = this.subHandlers[name]["class"];
      }
      if (((ref1 = this.activeSubHandlers) != null ? ref1[name] : void 0) != null) {
        if (calldestroy) {
          return this.activeSubHandlers[name].destroy();
        } else {
          this.activeSubHandlers[name] = null;
          return delete this.activeSubHandlers[name];
        }
      }
    };

    Handler.prototype.destroyAllSubHandlers = function() {
      var k, ref, results, v;
      ref = this.activeSubHandlers;
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(this.destroySubHandler(k, true));
      }
      return results;
    };

    Handler.prototype.refreshSubHandlers = function(subs) {
      var i, j, len, ref, results, results1, v;
      if (subs == null) {
        subs = [];
      }
      if (subs.length === 0) {
        ref = this.activeSubHandlers;
        results = [];
        for (i in ref) {
          v = ref[i];
          results.push(v.refresh());
        }
        return results;
      } else {
        results1 = [];
        for (j = 0, len = subs.length; j < len; j++) {
          i = subs[j];
          results1.push(this.activeSubHandlers[i].refresh());
        }
        return results1;
      }
    };

    Handler.prototype.loadLayout = function(options) {
      var callback, contentType, postOps, processData, ref, ref1, ref2, ref3, ref4, ref5, ref6, sel, selector, url;
      if (options == null) {
        options = {};
      }
      url = (ref = (ref1 = options.url) != null ? ref1 : this.layoutUrl) != null ? ref : this.layoutSource;
      postOps = (ref2 = (ref3 = options.postOptions) != null ? ref3 : this.loadLayoutPostOptions) != null ? ref2 : {};
      callback = (ref4 = options.callback) != null ? ref4 : null;
      selector = (ref5 = options.selector) != null ? ref5 : this.layoutSelector;
      sel = this._getLayoutSelector(selector);
      sel.empty();
      if (url == null) {
        if (callback != null) {
          return callback();
        }
      } else {
        if (url instanceof jQuery) {
          sel.html(url.html());
          if (callback != null) {
            return callback(sel, {});
          } else {
            if (this.autofocus) {
              if ((ref6 = sel.find('input,select')[0]) != null) {
                ref6.focus();
              }
            }
            return this.afterLoadLayout(sel, {});
          }
        } else {
          processData = true;
          contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
          if (postOps instanceof FormData) {
            processData = false;
            contentType = false;
          }
          return this.__request = $.ajax({
            type: 'POST',
            url: url,
            data: postOps,
            processData: processData,
            contentType: contentType,
            success: (function(_this) {
              return function(data) {
                var ref10, ref11, ref12, ref7, ref8, ref9;
                if (_this.__destroyed) {
                  return null;
                }
                if ((data != null) && ((ref7 = data.status) != null ? ref7.type : void 0) === 'logout') {
                  window.location = '/home';
                  return;
                }
                if (sel != null) {
                  if (_this.removeMessageOnLoad) {
                    sel.removeClass('dialog-loading');
                  }
                  if ((data != null) && (data.view != null)) {
                    sel.html(data.view);
                  } else {
                    sel.html(data);
                  }
                }
                if ((data != null) && ((ref8 = data.status) != null ? ref8.type : void 0) === 'denied') {
                  if ((ref9 = App.sidebar) != null) {
                    ref9.open();
                  }
                  if ((ref10 = App.sidebar) != null) {
                    if ((ref11 = ref10.contentDiv()) != null) {
                      ref11.html(data.view);
                    }
                  }
                  return;
                }
                _this.loadTaffy(data);
                if (callback != null) {
                  return callback(sel, data);
                } else {
                  if (_this.autofocus) {
                    if ((ref12 = sel.find('input,select')[0]) != null) {
                      ref12.focus();
                    }
                  }
                  return _this.afterLoadLayout(sel, data);
                }
              };
            })(this)
          });
        }
      }
    };

    Handler.prototype.loadTaffy = function(data) {
      var k, ref, results, v;
      if (data.taffy != null) {
        ref = data.taffy;
        results = [];
        for (k in ref) {
          v = ref[k];
          results.push(this.taffyObjects[k] = TAFFY(v));
        }
        return results;
      }
    };

    Handler.prototype.afterLoadLayout = function(selector, data) {
      return void 0;
    };

    Handler.prototype.selectSort = function(a, b) {
      if (a.text > b.text) {
        return 1;
      } else if (a.text < b.text) {
        return -1;
      }
      return 0;
    };

    Handler.prototype.moveOptions = function(from, to) {
      var j, len, sel, val, vals;
      if (!(from instanceof jQuery)) {
        from = $(from);
      }
      if (!(to instanceof jQuery)) {
        to = $(to);
      }
      vals = from.val();
      if (vals) {
        for (j = 0, len = vals.length; j < len; j++) {
          val = vals[j];
          sel = 'option[value="' + val + '"]';
          from.find(sel).appendTo(to);
          from.find(sel).remove();
        }
        to.find('option').sort(this.selectSort).appendTo(to);
        return to.val('');
      }
    };

    return Handler;

  })(DI);

}).call(this);
